import axios from 'axios';
import { message, Modal } from 'antd';

// 调试工具函数
const debug = {
  log: (category: string, ...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[${category.toUpperCase()}]`, ...args);
    }
  },
  error: (category: string, ...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(`[${category.toUpperCase()}]`, ...args);
    }
  },
  apiRequest: (method: string, url: string, data: any) => {
    if (process.env.NODE_ENV === 'development') {
      // console.log(`🚀 API请求: ${method} ${url}`, data);
      console.log("🚀 API请求成功")
    }
  },
  apiResponse: (method: string, url: string, status: number, data: any) => {
    if (process.env.NODE_ENV === 'development') {
      // console.log(`✅ API响应: ${method} ${url} [${status}]`, data);
      console.log("✅ API响应成功")
    }
  }
};

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8889/api';

// 开发环境打印API URL
if (process.env.NODE_ENV === 'development') {
  debug.log('api', 'API URL:', API_URL);
}

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 开发环境打印请求信息
    if (process.env.NODE_ENV === 'development') {
      debug.apiRequest(
        config.method?.toUpperCase() || 'GET',
        config.url || '',
        { params: config.params, data: config.data }
      );
    }
    
    return config;
  },
  (error) => {
    debug.error('api', '请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    // 开发环境打印响应信息
    if (process.env.NODE_ENV === 'development') {
      debug.apiResponse(
        response.config.method?.toUpperCase() || 'GET',
        response.config.url || '',
        response.status,
        response.data
      );
    }
    
    return response;
  },
  (error) => {
    // 打印详细错误信息
    debug.error('api', 'API 请求错误:', error);
    
    if (error.response) {
      const { status, data, config } = error.response;
      const errorMessage = data.message || data || error.message;
      
      debug.error('api', `请求失败: ${config.method?.toUpperCase() || 'GET'} ${config.url || ''}`, {
        status,
        data,
        headers: config.headers
      });
      
      switch (status) {
        case 400:
          message.error(errorMessage || '请求参数错误');
          break;
        case 401:
          // 认证错误，使用Modal确认框提供更好的用户体验
          Modal.confirm({
            title: '认证错误',
            content: errorMessage || '登录已过期，请重新登录',
            okText: '重新登录',
            cancelText: '取消',
            onOk: () => {
              localStorage.removeItem('token');
              window.location.href = '/login';
            }
          });
          break;
        case 403:
          message.error('没有权限访问');
          break;
        case 404:
          message.error('请求的资源不存在');
          break;
        case 500:
          message.error(errorMessage || '服务器错误，请稍后重试');
          break;
        default:
          // 其他错误
          if (errorMessage.includes('Token') || errorMessage.includes('login')) {
            Modal.confirm({
              title: '认证错误',
              content: errorMessage,
              okText: '重新登录',
              cancelText: '取消',
              onOk: () => {
                localStorage.removeItem('token');
                window.location.href = '/login';
              }
            });
          } else {
            message.error(`请求失败(${status}): ${errorMessage || '未知错误'}`);
          }
      }
    } else if (error.request) {
      debug.error('api', '网络请求未收到响应:', error.request);
      // 保留前端的倒计时重定向功能
      message.error('网络连接失败，5秒后将重新登录');
      setTimeout(() => {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }, 5000);
    } else {
      debug.error('api', '请求配置错误:', error.message);
      message.error(`请求错误: ${error.message}`);
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance; 